import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import purify from "dompurify";

export default function Description({ Copy, ...props }) {
  function removeCommentAttributes(inputObject) {
    for (const key in inputObject) {
      if (inputObject.hasOwnProperty(key) && key === "comment") {
        delete inputObject[key];
      }
    }
    return inputObject;
  }
  const wrapperStyle = removeCommentAttributes(props?.options?.wrapperStyle) || {};

  return (
    <Wrapper
      {...props}
      {...wrapperStyle}
      disableGutters={wrapperStyle?.disableGutters || true}
      maxWidth={wrapperStyle?.maxWidth || "lg"}
      align={wrapperStyle?.align || null}
      dangerouslySetInnerHTML={{ __html: purify.sanitize(Copy) }}
    />
  );
}
const Wrapper = styled(Container)`
  .raw-html-embed {
    margin-top: 5rem;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    flex-wrap: wrap;
    .column {
      display: flex;
      justify-content: space-evenly;
      align-content: center;
      flex-direction: column;
      max-width: 420px;
      min-width: 363px;
      padding: 0;
      ${props => props.theme.breakpoints.up("md")} {
        padding: 1.5rem;
      }
    }
  }
  ${props => {
    return { ...props.options.textBlockStyle };
  }}
`;
